module.exports = __webpack_public_path__ + "static/media/fotor-ai-202306221391.63189da9.jpg";